import { SET_LOCAL_AUDIO, SET_LOCAL_VIDEO, SET_BACKGROUND_FILTER } from "./waitingRoomAction"

const initialState = {
  numOfItems: 0,
  localAudio: false,
  localVideo: false,
  backgroundFilter: {
    filterName: '',
    filterPayload: ''
  },
};

const waitingRoomReducer = (state = initialState, action) => {
  switch (action.type) {

    case SET_LOCAL_AUDIO:
      return {
        ...state,
        localAudio: action.payload,
      };

    case SET_LOCAL_VIDEO:
      return {
        ...state,
        localVideo: action.payload,
      };
    case SET_BACKGROUND_FILTER:
      return {
        ...state,
        backgroundFilter: action.payload,
      };
    default:
      return state;
  }
};
export default waitingRoomReducer;
